import { ACTIONS } from './actionTypes'

export const openSearch = (open) => (
  { type: ACTIONS.OPEN_SEARCH, open }
);

export const setSearchResult = (result) => (
  { type: ACTIONS.SET_SEARCH_RESULT, result }
);

export const searchLoading = (loading) => (
  { type: ACTIONS.SEARCH_LOADING, loading }
);

export const searchString = value => (
  { type: ACTIONS.SET_SEARCH_STRING, value }
);

export const updateSearchParams = param => (
  { type: ACTIONS.UPDATE_SEARCH_PARAMS, param }
);



// WEBPACK FOOTER //
// ./src/redux/action/search_actions.js